export default [
  {
    timeStamp: moment.utc().format(),
    title: "TIPS FOR BETTER CHARACTER SKETCHING",
    slug: "/blogA",
    mainImg:
      "http://themes.pixelwars.org/cvcard-wp/wp-content/uploads/2014/04/lee.png",
    description:
      "Responsive web design offers us a way forward, finally allowing us to design for the ebb and flow of things. There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly."
  },
  {
    timeStamp: moment.utc().format(),
    title: "DESIGNING FOR A BEAUTIFUL WEB",
    description:
      "Responsive web design offers us a way forward, finally allowing us to design for the ebb and flow of things. There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly."
  },
  {
    timeStamp: moment.utc().format(),
    title: "POST FORMAT : LINK",
    description:
      "You should definetly visit this site, lots of useful stuff for web designers!",
    type: "link",
    link: {
      href: "http://www.google.com",
      title: "Google"
    }
  },
  {
    timeStamp: moment.utc().format(),
    title: "post format - no format | default",
    description: "I am having good time with my friends at Starbucks, classic!"
  },
  {
    timeStamp: moment.utc().format(),
    title: "POST FORMAT : CHAT",
    type: "chat",
    thread: [
      { author: "A", message: "hola !" },
      { author: "C", message: "hola !" },
      { author: "B", message: "hola !" },
      { author: "E", message: "hola, hola !" }
    ]
  },
  {
    timeStamp: moment.utc().format(),
    title: "10 TIPS FOR BETTER CHARACTER SKETCHING",
    description:
      "Responsive web design offers us a way forward, finally allowing us to design for the ebb and flow of things. There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly."
  },
  {
    timeStamp: moment.utc().format(),
    title: "BOOK / BRING IDEAS TO LIFE",
    type: "iframe",
    iframe: {
      src:
        "http://player.vimeo.com/video/75045142?title=0&amp;byline=0&amp;color=096",
      width: 500,
      height: 300
    },
    description:
      "Paper is where ideas begin. It’s the easiest and most beautiful way to create on the new iPad. Capture your ideas as sketches, diagrams, illustrations, notes or drawings and instantly share them across the web. Download “Paper by FiftyThree” from the App Store."
  },
  {
    timeStamp: moment.utc().format(),
    title: "POST FORMAT AUDIO SOUNDCLOUD EMBED",
    type: "iframe",
    iframe: {
      height: "166",
      src:
        "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/129829419&amp;color=009966&amp;auto_play=false&amp;show_artwork=true"
    },
    description:
      "Paper is where ideas begin. It’s the easiest and most beautiful way to create on the new iPad. Capture your ideas as sketches, diagrams, illustrations, notes or drawings and instantly share them across the web. Download “Paper by FiftyThree” from the App Store."
  },
  {
    timeStamp: moment.utc().format(),
    type: "quote",
    quote: {
      by: "Steave Jobs",
      message:
        "Design is not just what it looks like and feels like. Design is how it works."
    }
  },
  {
    timeStamp: moment.utc().format(),
    type: "aside",
    aside: `Responsive web design offers us a way forward, finally allowing us to design for the ebb and flow of things.There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words.
        `
  },
  {
    timeStamp: moment.utc().format(),
    subImg: `http://vl1263.ru/wp-content/uploads/2018/03/cheburashka.jpg`,
    description: `
          A beautiful illustration by
          <a
            href="http://dribbble.com/marie_bergeron "
            target="_blank"
          >Marie Bergeron.</a>`
  },
  {
    timeStamp: moment.utc().format(),
    title: "AN IMAGE GALLERY",
    type: "gallery",
    gallery: [
      {
        src:
          "http://www.kishankumarpatil.com/wp-content/uploads/2014/04/15.png",
        caption: "This is a slide title."
      },
      {
        src:
          "http://themes.pixelwars.org/cvcard-wp/wp-content/uploads/2014/04/lee.png"
      }
    ]
  },
  {
    timeStamp: moment.utc().format(),
    title: "SELF HOSTED HTML5 AUDIO",
    type: "audio",
    audio: {
      src: "http://www.largesound.com/ashborytour/sound/AshboryBYU.mp3",
      title: "Jazz Example"
    }
  },
  {
    timeStamp: moment.utc().format(),
    title: "SELF HOSTED HTML5 VIDEO",
    type: "video",
    video: {
      src:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
      title: "video self hosted"
    },
    description:
      "I just found a super cool video clip, you should definetly check it out. I loved the soundtrack."
  }
];
